
import Vue from "vue";

export default Vue.extend({
  name: "DividerField",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
});
